<template>
	<div class="iframe_wrap">
		<div class="iframe_body">
			<a href="javascript:;" class="close_btn" @click="close"></a>
			<iframe
				:src="url"
				sandbox="allow-scripts allow-top-navigation allow-same-origin"
			></iframe>
		</div>
	</div>
</template>

<script>
export default {
	props: ["url"],
	methods: {
		close: function () {
			this.$emit("close");
		},
	},
};
</script>

<style lang="less" scoped>
.iframe_wrap {
	position: absolute;
	z-index: 9;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.2);
	.iframe_body {
		width: 700px;
		height: 400px;
		position: absolute;
		left: 50%;
		margin-left: -350px;
		top: 50%;
		margin-top: -200px;
		box-shadow: 0px 0px 10px 4px #888888;
		background-color: #ffffff;
		border-radius: 4px;

		.close_btn {
			position: absolute;
			top: 10px;
			right: 20px;
			width: 20px;
			height: 20px;
			background-image: url(../assets/home/node/close.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			display: block;
			background-position: center center;
		}
		.close_btn:hover {
			opacity: 0.7;
			cursor: pointer;
		}
		iframe {
			width: 100%;
			height: 100%;
		}
	}
}
</style>